import React from "react";
import { useFormikContext } from "formik";
import equipmentPlaceholderImg from "../../../../../../../images/v2/equipment_placeholder.png";
import styles from "./style.module.scss";
import useEquipmentQuantity from "../../../../../hooks/useEquipmentQuantity";
import MinusGrayCircle from "../../../../../assets/svg/icons/common/minus-gray-circle";
import PlusGrayCircle from "../../../../../assets/svg/icons/common/plus-gray-circle";
import useUserStore from "../../../../../stores/user";

const Tag = ({ tag, type }) => {
  return <div className={`${styles.tag} ${styles[type]}`}>{tag}</div>;
};

const Equipment = ({ equipment, tag, apply_tpp, index }) => {
  const { equipment_name, equipment_image, type, quantity, id } = equipment;
  const { handleQuantityChange } = useEquipmentQuantity();
  const userOrgIsPaychex = useUserStore((state) => state.userOrgIsPaychex);
  const { values } = useFormikContext();

  const getPrice = () => {
    const price = equipment[`${type}_default`] || 0;
    return parseFloat(price).toFixed(2);
  };

  const renderPrice = () => {
    const price = getPrice();
    if (apply_tpp) {
      return (
        <div className={styles.tppPrice}>
          <s className={styles.originalPrice}>
            ${" "}
            {equipment.rent_for_default ||
              equipment.lease_for_default ||
              equipment.monthly_for_default ||
              equipment.purchase_for_default}
          </s>
          <span className={styles.discountedPrice}>$ 0.00</span>
        </div>
      );
    }
    return <span className={styles.price}>$ {price}</span>;
  };

  const showQuantityControls = () => {
    if (!userOrgIsPaychex) {
      return true;
    }

    if (type === "apply_tpp") {
      return false;
    }

    return true;
  };

  return (
    <div className={styles.container}>
      <div className={styles.imageContainer}>
        <img
          className={styles.img}
          src={`${equipment_image ? `/get-image-by-path?path=${equipment_image}` : equipmentPlaceholderImg}`}
          alt={equipment_name}
        />
      </div>
      <div className={styles.equipmentInfo}>
        <div className={styles.info}>
          <h5 className={styles.name}>
            <span className={styles.nameText}>{equipment_name}</span>
            {tag && <Tag tag={tag} type={tag} />}
          </h5>
          {renderPrice()}
        </div>
        {showQuantityControls() && (
          <div className={styles.quantityContainer}>
            <div className={styles.quantityStepper}>
              <button
                className={styles.stepperButton}
                onClick={() =>
                  handleQuantityChange(id, index, (quantity || 1) - 1)
                }
                type="button"
              >
                <MinusGrayCircle />
              </button>
              <span className={styles.quantity}>{quantity || 1}</span>
              <button
                className={styles.stepperButton}
                onClick={() =>
                  handleQuantityChange(id, index, (quantity || 1) + 1)
                }
                type="button"
              >
                <PlusGrayCircle />
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Equipment;
